// extracted by mini-css-extract-plugin
export var readonly = "_gv-1";
export var star = "_gv-0";